import { apiFetch } from './client'

export type SessionChannel = 'telegram' | 'web'
export type SessionStatus = 'running' | 'idle' | 'aborted' | 'error'
export type SessionInitKind = 'sso' | 'tg'
export type PermissionDecision = 'allow' | 'deny'

export interface OwnerSessionPermission {
  action: string
  path: string
  risk: string
}

export interface OwnerSessionDto {
  id: string
  channel: SessionChannel
  chatId: string
  agent: string
  project: string
  sprint: string | null
  initiator: string
  initKind: SessionInitKind
  startedAt: string
  lastActivityAt: string
  status: SessionStatus
  task: string | null
  errMsg?: string
  permission?: OwnerSessionPermission
}

export interface SessionTransferTarget {
  id: string
  name: string
  sprint: {
    id: string
    state: string
    goal: string
    done: number
    total: number
  } | null
  status: 'active' | 'planned' | 'closed'
  disabled?: boolean
}

export interface SessionMutationResult {
  ok?: boolean
  message?: string
}

export function fetchSessions(): Promise<OwnerSessionDto[]> {
  return apiFetch<OwnerSessionDto[]>('/api/sessions')
}

export function abortSession(id: string): Promise<SessionMutationResult> {
  return apiFetch<SessionMutationResult>(`/api/sessions/${encodeURIComponent(id)}/abort`, {
    method: 'POST',
  })
}

export function fetchSessionTransferTargets(id: string): Promise<SessionTransferTarget[]> {
  return apiFetch<SessionTransferTarget[]>(`/api/sessions/${encodeURIComponent(id)}/transfer/targets`)
}

export function diffSessionTransfer(
  id: string,
  targetProjectId: string,
): Promise<SessionMutationResult> {
  return apiFetch<SessionMutationResult>(`/api/sessions/${encodeURIComponent(id)}/transfer/diff`, {
    method: 'POST',
    json: { targetProjectId },
  })
}

export function confirmSessionTransfer(
  id: string,
  targetProjectId: string,
): Promise<SessionMutationResult> {
  return apiFetch<SessionMutationResult>(`/api/sessions/${encodeURIComponent(id)}/transfer/confirm`, {
    method: 'POST',
    json: { targetProjectId },
  })
}

export function decideSessionPermission(
  id: string,
  decision: PermissionDecision,
): Promise<SessionMutationResult> {
  return apiFetch<SessionMutationResult>(`/api/sessions/${encodeURIComponent(id)}/permission`, {
    method: 'POST',
    json: { decision },
  })
}
